import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { TablerIconsModule } from "angular-tabler-icons";
import { LandingSectionRevealDirective } from "../../shared/landing-section-reveal.directive";
import { scrollToLandingSection } from "../../shared/landing-section-scroll.helper";
import {
  LANDING_1_ONBOARDING_HIGHLIGHTS,
  LANDING_1_ONBOARDING_STEPS,
} from "../../landing-1.section-data";

@Component({
  selector: "app-landing-1-onboarding",
  standalone: true,
  imports: [TranslateModule, TablerIconsModule, LandingSectionRevealDirective],
  templateUrl: "./landing-1-onboarding.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Landing1OnboardingComponent {
  readonly steps = LANDING_1_ONBOARDING_STEPS;
  readonly highlights = LANDING_1_ONBOARDING_HIGHLIGHTS;

  scrollToSection(sectionId: string, event: Event): void {
    scrollToLandingSection(sectionId, event);
  }
}
